import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {v4 as uuidV4} from 'uuid';
import Checkbox from '@spothero/ui/checkbox';
import Label from '@spothero/ui/label';
import AmenityUtils from '@spothero/utils/amenity';

const FilterItem = ({
    className,
    slug,
    label,
    count,
    defaultChecked,
    disabled,
    showIcon,
    showCount,
    isQuickFilter,
    onChange,
    id,
}) => {
    const [key, setKey] = useState(uuidV4());
    const Icon = AmenityUtils.getIcon(slug);
    const classes = classNames('FilterItem', className);
    const onAmenityChange = ({target: {name, checked}}) => {
        onChange(name, checked, isQuickFilter);
    };

    useEffect(() => {
        setKey(uuidV4());
    }, [defaultChecked]);

    return (
        <div id={id} className="FilterItem-container">
            <Checkbox
                key={key}
                id={`FilterItem-${slug}`}
                className={classes}
                name={slug}
                defaultChecked={defaultChecked}
                label={
                    <Label className="FilterItem-label">
                        {showIcon && Icon && <Icon />}
                        {label} {showCount && <span>({count})</span>}
                    </Label>
                }
                disabled={disabled}
                onChange={onAmenityChange}
            />
        </div>
    );
};

FilterItem.propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
    slug: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    count: PropTypes.number,
    defaultChecked: PropTypes.bool,
    disabled: PropTypes.bool,
    showIcon: PropTypes.bool,
    showCount: PropTypes.bool,
    isQuickFilter: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
};

export default FilterItem;
